import angular from 'angular';
import _ from 'lodash/fp';
import defaultDialogTemplate from './views/default-dialog-template.html';

import DefaultDialogController from './default-dialog-controller';

const DIALOG_PARENT = angular.element(document.body);

const DEFAULT_TOAST_CONFIG = {
  closeButton: false,
  timeOut: 4000,
  tapToDismiss: true,
  positionClass: 'toast-top-center',
};

const DEFAULT_DIALOG_CONFIG = {
  controller: DefaultDialogController,
  controllerAs: '$ctrl',
  bindToController: true,
  backdrop: true,
  template: defaultDialogTemplate,
  animation: false,
  appendTo: DIALOG_PARENT,
  windowClass: 'dialog',
  backdropClass: 'backdrop-show',
  size: 'lg',
};

const NOTIFICATION_TYPES = {
  dialog: {
    success: 'open',
    error: 'open',
    confirm: 'open',
    config: DEFAULT_DIALOG_CONFIG,
  },
  toast: {
    success(config) {
      return this.toast.success(config.message, config);
    },
    error(config) {
      return this.toast.error(config.message, config);
    },
    warning(config) {
      return this.toast.warning(config.message, config);
    },
    info(config) {
      return this.toast.info(config.message, config);
    },
    config: DEFAULT_TOAST_CONFIG,
  },
};

function showNotification(config, type = 'dialog', actionKey = 'success') {
  const action = _.get(`${type}.${actionKey}`, NOTIFICATION_TYPES);
  return (_.get(`${type}.${action}`, this) || action.bind(this))(_.merge(NOTIFICATION_TYPES[type].config, config));
}

@Inject('$uibModal', 'toastr')
class NotificationService {
  constructor() {
    this.dialog = this.$uibModal;
    this.toast = this.toastr;
  }

  clear() {
    this.toast.clear();
  }

  showSimpleDialog(template) {
    return showNotification.call(this, {
      template,
    });
  }

  showComplexDialog(config) {
    return showNotification.call(this, config);
  }

  showAlert(title, content, config = {}) {
    return showNotification.call(
      this,
      Object.assign(config, {
        resolve: {
          title: () => title,
          content: () => content,
        },
      })
    );
  }

  alertSuccess(message) {
    return showNotification.call(this, { message }, 'toast');
  }

  alertError(message) {
    return showNotification.call(this, { message }, 'toast', 'error');
  }

  alertWarning(message) {
    return showNotification.call(this, { message }, 'toast', 'warning');
  }

  alertInfo(message) {
    return showNotification.call(this, { message }, 'toast', 'info');
  }

  customNotification(config, type, actionKey) {
    return showNotification.call(this, config, type, actionKey);
  }
}

export default angular.module('notifications', []).service('Notifications', NotificationService);



// WEBPACK FOOTER //
// ./src/modules/utils/notifications/notifications.js